import { formatAction, formatTimeAgo } from "../utils/formatters";

const ActivityItem = ({ log, isLast }) => (
  <div className="group relative flex gap-4 pb-6 last:pb-0">
    {/* Vertical connector line */}
    {!isLast && <div className="absolute left-[5px] top-4 bottom-0 w-[2px] bg-border-primary pointer-events-none" />}

    {/* Dot */}
    <div className="relative mt-[6px] h-3 w-3 shrink-0 rounded-full bg-button-secondary shadow-sm" />

    {/* Content */}
    <div className="flex flex-1 flex-col gap-1 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex flex-col md:flex-row md:gap-5">
        {/* "Note Added by Priya". The name comes from `changed_by_name`, which
            the server resolves off the actor row so a deactivated colleague
            still has one. A line with no actor — a system action, or data from
            before the field existed — renders the action alone, never a
            dangling "by". */}
        <span className="text-text-primary text-sm">{formatAction(log.action)}{log.new_value?.question_type &&
    ` - ${formatAction(log.new_value.question_type)}`}{log.changed_by_name && ` by ${log.changed_by_name}`}</span>

        {log.old_value?.status && log.new_value?.status && (
          <span className="text-text-secondary text-xs mt-1">
            {formatAction(log.old_value.status)} &rarr; {formatAction(log.new_value.status)}
          </span>
        )}
      </div>

      <span className="text-text-secondary text-xs shrink-0 md:mt-1">{formatTimeAgo(log.changed_at)}</span>
    </div>
  </div>
);

export default ActivityItem;
